import DashboardLayout from '../components/DashboardLayout';

export default function MediaLibrary() {
  return (
    <DashboardLayout>
      <div>
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Media Library</h1>
        <div className="card">
          <p className="text-gray-600">Media library coming soon...</p>
        </div>
      </div>
    </DashboardLayout>
  );
}
